export default "__VITE_ASSET__Havr331a__"